<template>
  <div>
    <h3>内容管理</h3>

    <el-row :gutter="10" style="margin-bottom:15px;">
      <el-col :span="6">
        <el-select v-model="queryAppId" filterable placeholder="APP">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in appList" :key="item.appId" :label="item.appId" :value="item.appId"></el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-select v-model="queryFormat" placeholder="类型">
          <el-option label="全部" value=""></el-option>
          <el-option label="图文" :value="1"></el-option>
          <el-option label="视频" :value="2"></el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-input v-model="searchTitle" placeholder="标题"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="getList">查询</el-button>
      </el-col>
      <el-col :span="4">
        <el-button type="success" @click="addShow=true;resetForm()">新增</el-button>
      </el-col>
    </el-row>

    <el-table :data="list" border>
      <el-table-column prop="appId" label="APP"></el-table-column>
      <el-table-column prop="format" label="类型" :formatter="f=>f.format==1?'图文':'视频'"></el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="topics" label="话题" width="180"></el-table-column>
      <el-table-column prop="layout_type" label="布局" :formatter="fmtLayout"></el-table-column>
      <el-table-column label="操作">
        <template #default="{row}">
          <el-button @click="openEdit(row)">修改</el-button>
          <el-button type="danger" @click="del(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

 <el-pagination
  :current-page.sync="pageNum"
  :page-size.sync="pageSize"
  :total="total"
  style="margin-top:20px;text-align:right;"
  background
  layout="total, sizes, prev, pager, next, jumper"
  @size-change="getList"
  @current-change="getList"
/>

    <!-- 新增弹窗 -->
    <el-dialog
      title="新增"
      :visible.sync="addShow"
      width="850px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="form">
        <el-form-item label="APP">
          <el-select v-model="form.appId" filterable @change="loadCate">
            <el-option v-for="item in appList" :key="item.appId" :label="item.appId" :value="item.appId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="分类">
          <el-select v-model="form.cate_id">
            <el-option v-for="c in cateList" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="发布人头像">
          <div style="display: flex; align-items: center; gap: 10px;">
            <img
              v-if="form.user_avatar"
              :src="form.user_avatar"
              style="width:60px;height:60px;border-radius:50%;object-fit:cover;"
            >
            <el-button type="primary" size="mini" @click="uploadAvatar">上传头像</el-button>
          </div>
        </el-form-item>

        <el-form-item label="发布人昵称">
          <el-input v-model="form.user_nickname" placeholder="输入昵称"></el-input>
        </el-form-item>

        <el-form-item label="话题（多个用,分隔）">
          <el-input v-model="form.topics" placeholder="例如：新闻,热点,生活"></el-input>
        </el-form-item>

        <el-form-item label="内容类型">
          <el-radio-group v-model="form.format" @change="onTypeChange">
            <el-radio :label="1">图文</el-radio>
            <el-radio :label="2">视频</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="视频地址" v-if="form.format==2">
          <el-input v-model="form.video_url"></el-input>
        </el-form-item>

        <el-form-item label="封面图片">
          <div style="display:flex;gap:8px;flex-wrap:wrap;">
            <div v-for="(u,i) in covers" :key="i" style="width:100px;height:100px;position:relative">
              <img :src="u" style="width:100%;height:100%;object-fit:cover">
              <el-button type="danger" size="mini" icon="el-icon-close" circle style="position:absolute;top:-6px;right:-6px" @click="covers.splice(i,1)"></el-button>
            </div>
            <div v-if="canAddCover" style="width:100px;height:100px;border:1px dashed #ccc;display:grid;place-items:center" @click="upload">+上传</div>
          </div>
        </el-form-item>

        <el-form-item label="布局方式" v-if="showLayout">
          <el-select v-model="form.layout_type" :disabled="forceLayout">
            <el-option label="上图下文" :value="1"></el-option>
            <el-option label="左图右文" :value="2"></el-option>
            <el-option label="左文右图" :value="3"></el-option>
            <el-option label="上文下图" :value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标题"><el-input v-model="form.title"></el-input></el-form-item>
        <el-form-item label="简介"><el-input type="textarea" :rows="2" v-model="form.intro"></el-input></el-form-item>

        <el-form-item label="内容">
          <el-button type="text" @click="toggleSource" style="margin-bottom:8px;">
            {{ isSourceMode ? '切换富文本' : '切换源码' }}
          </el-button>
          <div v-show="!isSourceMode" id="richEditor" style="height:320px; border:1px solid #E4E7ED; border-radius:4px;"></div>
          <textarea
            v-show="isSourceMode"
            v-model="form.content"
            style="width:100%;height:320px;border:1px solid #E4E7ED;border-radius:4px;padding:10px;white-space:pre-wrap;"
          ></textarea>
        </el-form-item>

      </el-form>
      <div slot="footer">
        <el-button @click="addShow=false; destroyEditor()">取消</el-button>
        <el-button type="primary" @click="submitAdd">确定</el-button>
      </div>
    </el-dialog>

    <!-- 修改弹窗 -->
    <el-dialog
      title="修改"
      :visible.sync="editShow"
      width="850px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="form">
        <el-form-item label="类型">
          <el-radio-group disabled v-model="form.format">
            <el-radio :label="1">图文</el-radio>
            <el-radio :label="2">视频</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="发布人头像">
          <div style="display: flex; align-items: center; gap: 10px;">
            <img
              v-if="form.user_avatar"
              :src="form.user_avatar"
              style="width:60px;height:60px;border-radius:50%;object-fit:cover;"
            >
            <el-button type="primary" size="mini" @click="uploadAvatar">重新上传</el-button>
          </div>
        </el-form-item>

        <el-form-item label="发布人昵称">
          <el-input v-model="form.user_nickname"></el-input>
        </el-form-item>

        <el-form-item label="话题">
          <el-input v-model="form.topics"></el-input>
        </el-form-item>

        <el-form-item label="视频地址" v-if="form.format==2">
          <el-input v-model="form.video_url"></el-input>
        </el-form-item>
        
        <el-form-item label="封面">
          <div style="display:flex;gap:8px;flex-wrap:wrap">
            <div v-for="(u,i) in covers" :key="i" style="width:100px;height:100px;position:relative">
              <img :src="u" style="width:100%;height:100%;object-fit:cover">
              <el-button type="danger" size="mini" icon="el-icon-close" circle style="position:absolute;top:-6px;right:-6px" @click="covers.splice(i,1)"></el-button>
            </div>
            <div v-if="canAddCover" style="width:100px;height:100px;border:1px dashed #ccc;display:grid;place-items:center" @click="upload">+上传</div>
          </div>
        </el-form-item>
        
        <el-form-item label="布局" v-if="showLayout">
          <el-select v-model="form.layout_type" :disabled="forceLayout">
            <el-option label="上图下文" :value="1"></el-option>
            <el-option label="左图右文" :value="2"></el-option>
            <el-option label="左文右图" :value="3"></el-option>
            <el-option label="上文下图" :value="4"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="标题"><el-input v-model="form.title"></el-input></el-form-item>
        <el-form-item label="简介"><el-input v-model="form.intro"></el-input></el-form-item>

        <el-form-item label="内容">
          <el-button type="text" @click="toggleSource" style="margin-bottom:8px;">
            {{ isSourceMode ? '切换富文本' : '切换源码' }}
          </el-button>
          <div v-show="!isSourceMode" id="richEditorEdit" style="height:320px; border:1px solid #E4E7ED; border-radius:4px;"></div>
          <textarea
            v-show="isSourceMode"
            v-model="form.content"
            style="width:100%;height:320px;border:1px solid #E4E7ED;border-radius:4px;padding:10px;white-space:pre-wrap;"
          ></textarea>
        </el-form-item>

      </el-form>
      <div slot="footer">
        <el-button @click="editShow=false; destroyEditor()">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import req from '@/api/request'
import E from 'wangeditor'

export default {
  data() {
    return {
      appList: [],
      cateList: [],
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      queryAppId: '',
      queryFormat: '',
      searchTitle: '',
      addShow: false,
      editShow: false,
      form: {
        id: '',
        appId: '',
        cate_id: '',
        format: 1,
        layout_type: 1,
        title: '',
        intro: '',
        content: '',
        video_url: '',
        cover_imgs: '',
        user_avatar: '',
        user_nickname: '',
        topics: ''
      },
      covers: [],
      editor: null,
      isSourceMode: false
    }
  },
  computed: {
    canAddCover() {
      if (this.form.format === 2) return this.covers.length < 1
      return this.covers.length < 3
    },
    showLayout() {
      if (this.form.format === 2) return false
      return this.covers.length > 0
    },
    forceLayout() {
      return this.form.format === 1 && this.covers.length > 1
    }
  },
  methods: {
    fmtLayout(r) {
      const m = { 1: '上图下文', 2: '左图右文', 3: '左文右图', 4: '上文下图' }
      return m[r.layout_type] || '无'
    },
    async uploadAvatar() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = async e => {
        const fd = new FormData()
        fd.append('file', e.target.files[0])
        const res = await req.post('/upload/image', fd)
        if (res.code === 200) {
          this.form.user_avatar = res.data.url
        }
      }
      input.click()
    },
    async loadApp() {
      const r = await req.get('/admin/app/list')
      this.appList = r.data || []
    },
    async loadCate(a) {
      if (!a) { 
        this.cateList = []; 
        return;
      }
      // 1. 加载分类
      const r = await req.get('/admin/category/list', { params: { appId: a } });
      this.cateList = r.data?.list || [];

      // 2. 加载APP信息，自动设置默认 layout_type
      const appInfo = await req.get('/admin/app/info', { params: { appId: a } });
      if (appInfo.code === 200) {
        this.form.layout_type = appInfo.data.layout_type || 1;
      }
    },
    onTypeChange() {
      this.covers = []
      this.form.layout_type = 1
    },
    async upload() {
      const i = document.createElement('input')
      i.type = 'file'
      i.accept = 'image/*'
      i.onchange = async e => {
        const fd = new FormData()
        fd.append('file', e.target.files[0])
        const r = await req.post('/upload/image', fd)
        if (r.code === 200) {
          const u = r.data.url
          if (this.form.format === 2) this.covers = [u]
          else this.covers.push(u)
          if (this.covers.length > 1) this.form.layout_type = 1
        }
      }
      i.click()
    },
    async getList() {
      const r = await req.get('/admin/content/list', {
        params: {
          appId: this.queryAppId,
          format: this.queryFormat,
          title: this.searchTitle,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      })
      this.list = r.data?.list || []
      this.total = r.data?.total || 0
    },
    resetForm() {
      this.form = {
        id: '', appId: '', cate_id: '', format: 1, layout_type: 1,
        title: '', intro: '', content: '', video_url: '', cover_imgs: '',
        user_avatar: '', user_nickname: '', topics: ''
      }
      this.covers = []
      this.isSourceMode = false
      this.$nextTick(() => {
        this.initEditor('richEditor')
      })
    },
    async submitAdd() {
      if (!this.form.appId || !this.form.cate_id || !this.form.title) {
        return this.$message.warning('请完善必填项')
      }
      if (!this.isSourceMode && this.editor) {
        this.form.content = this.editor.txt.html()
      }
      this.form.cover_imgs = this.covers.join(',')
      const r = await req.post('/admin/content/add', this.form)
      if (r.code === 200) {
        this.$message.success('成功')
        this.addShow = false
        this.destroyEditor()
        this.getList()
      }
    },
    async openEdit(r) {
      this.form = { ...r }
      this.covers = r.cover_imgs ? r.cover_imgs.split(',') : []
      this.isSourceMode = false
      await this.loadCate(r.appId)
      
      this.editShow = true
      this.$nextTick(() => {
        this.initEditor('richEditorEdit')
        this.editor.txt.html(this.form.content || '')
      })
    },
    async submitEdit() {
      if (!this.isSourceMode && this.editor) {
        this.form.content = this.editor.txt.html()
      }
      this.form.cover_imgs = this.covers.join(',')
      const r = await req.post('/admin/content/edit', this.form)
      if (r.code === 200) {
        this.$message.success('成功')
        this.editShow = false
        this.destroyEditor()
        this.getList()
      }
    },
    async del(id) {
      await req.post('/admin/content/del', { id })
      this.getList()
    },

    initEditor(elemId) {
      this.destroyEditor()
      this.editor = new E(`#${elemId}`)
      this.editor.config.showLinkImg = false
      this.editor.config.showLinkVideo = false
      this.editor.config.uploadImgServer = '/api/upload/image'
      this.editor.config.uploadImgFileName = 'file'
      this.editor.config.uploadImgMaxSize = 20 * 1024 * 1024
      this.editor.config.uploadImgHooks = {
        customInsert: (insertImg, result) => {
          if (result.code === 200) insertImg(result.data.url)
        }
      }
      this.editor.create()
    },

    toggleSource() {
      if (!this.editor) return
      if (this.isSourceMode) {
        this.editor.txt.html(this.form.content)
      } else {
        this.form.content = this.editor.txt.html()
      }
      this.isSourceMode = !this.isSourceMode
    },

    destroyEditor() {
      if (this.editor) {
        this.editor.destroy()
        this.editor = null
      }
    },
  },
  mounted() {
    this.loadApp()
    this.getList()
  }
}
</script>

<style>
</style>